export const SET_CYCO_FINANCING_OPTION = 'SET_CYCO_FINANCING_OPTION';
export const SET_CYCO_FAILED_VALIDATION = 'SET_CYCO_FAILED_VALIDATION';
